import React from "react";
import StaticPage from "../../components/StaticPage";
import PolicySection from "./PolicySection";
import { PRIVACY } from "./policyContent";

export default function PrivacyPolicyPage() {
  return (
    <StaticPage
      title="Privacy Policy"
      seoDescription="How Bindal's Creation handles your personal information."
    >
      {PRIVACY.map((s) => (
        <PolicySection key={s.heading} {...s} />
      ))}
    </StaticPage>
  );
}
